<script>
  export let title = "Are you sure?";
  export let message = "Are you sure?";
  export let show = false;
  const onAccept = function (event) {
    show = !show

  }
</script>

<style>
  .modal-background {
    background-color: rgba(10, 10, 10, 0.8);
  }
</style>

<div class="modal" class:is-active={show}>
  <div class="modal-background"/>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">{title}</p>
    </header>
    <section class="modal-card-body">
      {message}
    </section>
    <footer class="modal-card-foot">
      <button class="button is-success" on:click={onAccept}>OK</button>

    </footer>
  </div>
</div>
